import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';

import { fetchPriceLevels, editMultiPriceLevels } from '../../actions/products_actions';
import { fetchInventoryReturns, editInventoryReturns, fetchInventoryReturnsDetails, voidReturn, completeReturn } from '../../actions/sales_actions';
import { setDefaultDays } from '../../actions/purchaseOrders_actions';
import { checkPassword, clearCheckPassword } from '../../actions/settings_actions';
import InventoryReturn from '../../components/Returns/inventoryReturn';

let inventoryReturn = reduxForm({
  form: 'inventoryReturn',
})(InventoryReturn);

const selector = formValueSelector('inventoryReturn');

function mapStateToProps(state) {
  const Days = selector(state, 'Days');
  const FromDate = selector(state, 'FromDate');
  const ToDate = selector(state, 'ToDate');
  return {
    Days,
    FromDate,
    ToDate,
    updated: state.salesInvoice.updated,
    inventoryReturn: state.salesInvoice.inventoryReturn,
    inventoryReturnIsLoading: state.salesInvoice.inventoryReturnIsLoading,
    inventoryReturnError: state.salesInvoice.inventoryReturnError,
    inventoryReturnDetailsError: state.salesInvoice.inventoryReturnDetailsError,
    inventoryReturnDetailsIsLoading: state.salesInvoice.inventoryReturnDetailsIsLoading,
    inventoryReturnIsEditing: state.salesInvoice.inventoryReturnIsEditing,
    editInventoryReturnError: state.salesInvoice.editInventoryReturnError,
    inventoryReturnEdited: state.salesInvoice.inventoryReturnEdited,
    inventoryReturnDetails: state.salesInvoice.inventoryReturnDetails,

    checkPassword: state.settings.checkPassword,
    checkPasswordSuccess: state.settings.checkPasswordSuccess,
    checkPasswordFailure: state.settings.checkPasswordFailure,
  };
}

export default connect(mapStateToProps, {
  setDefaultDays,
  fetchInventoryReturns,
  editInventoryReturns,
  fetchPriceLevels,
  editMultiPriceLevels,
  fetchInventoryReturnsDetails,
  voidReturn,
  completeReturn,
  checkPassword,
  clearCheckPassword,
})(inventoryReturn);



// WEBPACK FOOTER //
// ./master/jsx/containers/Returns/inventoryReturn.jsx